import { trpc } from '@/lib/trpc';

const useGetWishes = (id_list: number) => {
	const { data, isFetching } = trpc.wish.get.useQuery(
		{ id_list },
		{ refetchOnMount: false }
	);

	return {
		wishes: data?.wishes,
		wishesLoading: isFetching,
	};
};

export default useGetWishes;
